module.exports = __webpack_public_path__ + "assets/img/sochi-2017-m.8796e4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/topics/sochi-2017-m.jpg
// module id = 0HEY
// module chunks = 0